import React from 'react';
import { DispatchEvent, GlobalApplicationContext } from './SmartTypes';

export const GlobalContext = React.createContext({
    globalState: {},
    globalDispatch: (dispatchEvent: DispatchEvent) => {},
} as GlobalApplicationContext);

// Bridge that mirrors the latest globalState/globalDispatch for the small number of
// non-React call sites (router loaders, plain service/action functions) that need to
// read/write the app's global state but can't use useContext. Kept in sync by
// App.tsx on every render.
export const globalStateBridge: GlobalApplicationContext = {
    globalState: {} as GlobalApplicationContext['globalState'],
    globalDispatch: (dispatchEvent: DispatchEvent) => {},
};
